export default __webpack_public_path__ + "static/media/upload-cloud.a94b24ba.svg";